import React from 'react';
import { Box, Link } from '@mui/material';

/**
 * SkipLink Component
 * 
 * Provides keyboard-accessible skip links for jumping to main content.
 * Visible only on focus to avoid visual clutter.
 * Essential for WCAG 2.1 Level A compliance.
 * 
 * Usage:
 * <SkipLink href="#main-content" />
 */
interface SkipLinkProps {
  /** Target element ID to skip to */
  href: string;
  /** Link text (default: "Skip to main content") */
  text?: string;
}

export const SkipLink: React.FC<SkipLinkProps> = ({ 
  href, 
  text = 'Skip to main content' 
}) => {
  return (
    <Link
      href={href}
      sx={{
        position: 'absolute',
        top: '-40px',
        left: 0,
        backgroundColor: (theme) => theme.palette.primary.main,
        color: 'white',
        padding: '8px 12px',
        textDecoration: 'none',
        zIndex: 100,
        '&:focus': {
          top: 0,
        },
        '&:focus-visible': {
          top: 0,
        },
      }}
    >
      {text}
    </Link>
  );
};

export default SkipLink;
